if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
                // Show the social end card when an uploaded video ends.
        this.addEventListener('ended', (event) => {
          const video = event.target;
          if (!(video instanceof HTMLVideoElement)) return;

          const mediaItem = video.closest('.product__media-item');

          const template = this.querySelector(
            'template[data-product-video-end-card]'
          );
          const container = video.closest('.product-media-container');

          if (!mediaItem || !template || !container) return;
          if (!mediaItem.classList.contains('is-active')) return;

          let card = container.querySelector('.product-video-end-card');

          if (!card) {
            card = template.content.firstElementChild.cloneNode(true);

            if (getComputedStyle(container).position === 'static') {
              container.style.position = 'relative';
            }

            card.hidden = true;
            container.append(card);

            const replay = card.querySelector(
              '.product-video-end-card__replay'
            );

            replay?.addEventListener('click', async () => {
              card.hidden = true;
              video.currentTime = 0;

              try {
                await video.play();
              } catch (error) {
                if (error.name !== 'NotAllowedError') return;

                video.muted = true;

                try {
                  await video.play();
                } catch (mutedError) {
                  // Native video controls remain available.
                }
              }
            });
          }

          card.hidden = false;
        }, true);

        // Hide the end card whenever its video resumes playing.
        this.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement)) return;

          const container = event.target.closest(
            '.product-media-container'
          );
          const card = container?.querySelector(
            '.product-video-end-card'
          );

          if (card) card.hidden = true;
        }, true);

        // Clear end cards when the customer selects another thumbnail.
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          if (!event.target.closest(
            '[id^="GalleryThumbnails"] button'
          )) return;

          this.querySelectorAll('.product-video-end-card').forEach(
            (card) => {
              card.hidden = true;
            }
          );
        }, true);

                const videoShortcut = this.querySelector('[data-video-media-id]');
                        if (videoShortcut) {
          const productSection = this.closest('[id^="MainProduct-"]');
          const priceBlock = productSection?.querySelector('[id^="price-"]');

                    if (priceBlock) {
            const shippingNote = productSection.querySelector('.product__tax');

            videoShortcut.classList.remove('button', 'button--secondary');

            const playIcon = document.createElement('span');
            playIcon.textContent = '▶';
            playIcon.setAttribute('aria-hidden', 'true');
            playIcon.style.cssText =
              'display:inline-flex;align-items:center;justify-content:center;' +
              'width:16px;height:16px;border:1px solid currentColor;' +
              'border-radius:50%;font-size:8px;line-height:1;' +
              'flex:0 0 16px;';

            const label = document.createElement('span');
            label.textContent = 'Watch Product Video';

            videoShortcut.replaceChildren(playIcon, label);
            videoShortcut.setAttribute('aria-label', 'Watch Product Video');

            const buttonRow = document.createElement('div');
            buttonRow.className = 'product-video-action';
            buttonRow.style.cssText =
              'display:block;width:100%;margin:14px 0 16px;';

            buttonRow.append(videoShortcut);

            if (shippingNote) {
              shippingNote.after(buttonRow);
            } else {
              priceBlock.after(buttonRow);
            }

            videoShortcut.style.cssText =
              'position:static;display:inline-flex;align-items:center;' +
              'justify-content:center;gap:10px;width:auto;max-width:100%;' +
              'min-width:0;min-height:46px;margin:0;padding:12px 20px;' +
              'background:#082b59;color:#fff;border:1px solid #082b59;' +
              'border-radius:5px;box-shadow:none;' +
              'font-family:inherit;font-size:14px;font-weight:600;' +
              'line-height:1.4;text-align:center;cursor:pointer;';
          }

        }


        if (videoShortcut) {
          videoShortcut.addEventListener('click', () => {
            const mediaId = videoShortcut.dataset.videoMediaId;
            const activeMedia = this.elements.viewer.querySelector(
              `[data-media-id="${mediaId}"]`
            );

            if (!activeMedia) return;

            this.setActiveMedia(mediaId, false);

            const thumbnail = this.elements.thumbnails?.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (thumbnail) {
              thumbnail.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
            }
          });
        }

                // Auto-play the first uploaded product video on product pages.
        if (
          videoShortcut &&
          window.location.pathname.includes('/products/') &&
          this.closest('[id^="MainProduct-"]')
        ) {
          const startProductVideo = async () => {
            if (!this.isConnected) return;

            const mediaId = videoShortcut.dataset.videoMediaId;
            const mediaItem = this.elements.viewer.querySelector(
              `[data-media-id="${mediaId}"]`
            );

            if (!mediaItem) return;

            const deferred = mediaItem.querySelector('deferred-media');
            if (!deferred) return;

            // This version handles videos uploaded to Shopify.
            const template = deferred.querySelector('template');
            const hasUploadedVideo =
              deferred.querySelector('video') ||
              template?.content.querySelector('video');

            if (!hasUploadedVideo) return;

            await customElements.whenDefined('deferred-media');
            if (!this.isConnected) return;

            this.setActiveMedia(mediaId, false);

            const thumbnail = this.elements.thumbnails?.querySelector(
              `[data-target="${mediaId}"]`
            );

            thumbnail?.scrollIntoView({
              behavior: 'instant',
              block: 'nearest',
              inline: 'nearest'
            });

            const video = deferred.querySelector('video');
            if (!video) return;

            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.muted = false;

            try {
              await video.play();
            } catch (error) {
              if (
                error.name !== 'NotAllowedError' ||
                !mediaItem.classList.contains('is-active')
              ) return;

              video.muted = true;

              try {
                await video.play();
              } catch (mutedError) {
                // Keep native controls if autoplay is still blocked.
              }
            }
          };

          const scheduleProductVideo = () => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                startProductVideo().catch(console.warn);
              });
            });
          };

          if (document.readyState === 'loading') {
            document.addEventListener(
              'DOMContentLoaded',
              scheduleProductVideo,
              { once: true }
            );
          } else {
            scheduleProductVideo();
          }
        }

                // Picture carousel: customer interaction always takes priority.
        {
          const section = this.closest('[id^="MainProduct-"]');
                    let row = section?.querySelector('.product-video-action');

          if (
            section &&
            !row &&
            this.id === `MediaGallery-${section.id.replace('MainProduct-', '')}`
          ) {
            const shippingNote = section.querySelector('.product__tax');
            const priceBlock = section.querySelector('[id^="price-"]');
            const anchor = shippingNote || priceBlock;

            if (anchor) {
              row = document.createElement('div');
              row.className = 'product-video-action';
              anchor.after(row);
            }
          }

          const pictures = Array.from(
            this.elements.viewer.querySelectorAll(
              '.product__media-item[data-media-id]'
            )
          ).filter((slide) =>
            slide.querySelector('.product-media-container.media-type-image')
          );

          if (row && pictures.length > 1) {
            row.style.cssText =
              'display:flex;align-items:center;flex-wrap:wrap;' +
              'gap:10px;width:100%;margin:14px 0 16px;';

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'product-picture-carousel';
            button.setAttribute('aria-pressed', 'false');

                        if (videoShortcut) {
              button.style.cssText = videoShortcut.style.cssText;
            } else {
              button.style.cssText =
                'position:static;display:inline-flex;align-items:center;' +
                'justify-content:center;gap:10px;width:auto;max-width:100%;' +
                'min-width:0;min-height:46px;margin:0;padding:12px 20px;' +
                'background:#082b59;color:#fff;border:1px solid #082b59;' +
                'border-radius:5px;box-shadow:none;' +
                'font-family:inherit;font-size:14px;font-weight:600;' +
                'line-height:1.4;text-align:center;cursor:pointer;';
            }


            const icon = document.createElement('span');
            icon.textContent = '▧';
            icon.setAttribute('aria-hidden', 'true');

            const label = document.createElement('span');
            label.textContent = 'Picture Carousel';

            button.append(icon, label);
            row.append(button);

            let timer = null;
            let index = 0;

            const stop = () => {
              window.clearInterval(timer);
              timer = null;
              button.setAttribute('aria-pressed', 'false');
              label.textContent = 'Picture Carousel';
            };

            const showPicture = () => {
              const slide = pictures[index];

              this.querySelectorAll('.product-video-end-card').forEach(
                (card) => {
                  card.hidden = true;
                }
              );

              this.pictureCarouselSwitching = true;

              try {
                this.setActiveMedia(slide.dataset.mediaId, false);
              } finally {
                this.pictureCarouselSwitching = false;
              }

              const thumbnail = this.elements.thumbnails?.querySelector(
                `[data-target="${slide.dataset.mediaId}"]`
              );

              thumbnail?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
            };

            button.addEventListener('click', () => {
              if (timer !== null) {
                stop();
                return;
              }

              index = 0;
              showPicture();
              button.setAttribute('aria-pressed', 'true');
              label.textContent = 'Pause Carousel';

              timer = window.setInterval(() => {
                if (!this.isConnected || document.hidden) {
                  stop();
                  return;
                }

                index = (index + 1) % pictures.length;
                showPicture();
              }, 4000);
            });

            // Only stop the timer. Never block the original action.
            const stopOnOtherInteraction = (event) => {
              if (!this.isConnected) {
                stop();
                return;
              }

              if (
                event.target instanceof Node &&
                button.contains(event.target)
              ) return;

              stop();
            };

            document.addEventListener(
              'pointerdown', stopOnOtherInteraction, true
            );
            document.addEventListener(
              'click', stopOnOtherInteraction, true
            );
                        section.addEventListener('change', () => {
              if (this.pictureCarouselSwitching) return;
              stop();
            }, true);


            document.addEventListener('visibilitychange', () => {
              if (document.hidden) stop();
            });

            window.addEventListener('pagehide', stop);
          }
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
                  try {
          this.syncVariantToMedia(mediaId);
        } catch (error) {
          console.warn('型号联动未完成，图片切换继续：', error);
        }

               if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }

      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
          syncVariantToMedia(mediaId) {
      const numericMediaId = mediaId.split('-').pop();
      const variantRadios = document.querySelector('variant-radios');
      if (!variantRadios) return;

      const variantData = JSON.parse(variantRadios.querySelector('[type="application/json"]').textContent);
      const matchedVariant = variantData.find(
        (v) => v.featured_media && String(v.featured_media.id) === String(numericMediaId)
      );
      if (!matchedVariant) return;

      const radioInput = variantRadios.querySelector(
        `input[type="radio"][value="${matchedVariant.option1}"]`
      );
      if (radioInput && !radioInput.checked) {
        radioInput.checked = true;
        radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    }
  );
}
